<template>
  <div class="dashboard-container">
    <a-row :gutter="20" class="bootcamp">
      <a-col :span="isDesktop ? 16 : 24">
        <a-card title="Evangelism Boot Camp" class="style1">
          <a-row :gutter="20" class="bootcamp">
            <a-col class="text-center">
              <iframe :src="videoUrl" width="640" height="300" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            </a-col>
          </a-row>
          <a-row>
            <a-col class="text-center" style="margin: 1rem auto;">
              <a class="tf-text-primary text-underline" :href="'https://truelifeorg.s3.amazonaws.com/resources/assets/EBC_eBook.pdf'" download="Evangelism_Boot_Camp.pdf" target="_blank">
                Download EBook
              </a>
            </a-col>
          </a-row>
          <a-row>
            <a-col class="text-center" style="margin: 1rem auto;">
              <a class="tf-text-primary text-underline" :href="'https://truelifeorg.s3.amazonaws.com/resources/assets/Leader_eBook.pdf'" download="Leader_eBook.pdf" target="_blank">
                Download Leader Guide
              </a>
            </a-col>
          </a-row>
          <a-row>
            <a-col class="ebook-wrapper">
              <br />
              <p style="white-space: pre-line; text-align: center;">
                <b>Forward by Josh McDowell</b>
              </p>

              <p>
                I have had the pleasure of knowing Jesse Connors for about 10 years. I first met him when I came to his studio to film two very well done movies for TrueLife.org on “Why Does God Allow
                Abuse?” and “Did Jesus Fulfill Prophecy?” After I was done filming he gave me some battery operated Christmas lights to wear around my neck as a thank you. I took those lights home and
                put them on my car rearview mirror and started praying for Jesse. Jesse is certainly a ball of energy, but I knew his energy is directed in helping people to know Jesus as their Lord
                and Savior. I prayed that God would use him in a mighty way. As we fast forward through time to today, I can see my prayers are being answered for him.
              </p>

              <p>
                Evangelism Boot Camp is fun, but at the same time it is the most comprehensive, powerful, and easy evangelism training strategy available to the Church today. You may have felt that
                sharing your faith and doing your part in fulfilling the Great Commission was out of reach for you, but after you complete Evangelism Boot Camp you’ll never feel that way again.
              </p>
              <p>
                In fact, as soon as you begin to read the first page you will be drawn into a new world where your passion and commitment to evangelism will grow tremendously. You will know how to
                better put on your spiritual armor. You will have a biblical view of who your neighbors really are and how to love them as yourself. You will learn how to share the Gospel and what to
                say when you have five seconds, five minutes, or an hour. He prepares you for the most probable worldviews that you will encounter, like Mormanism and Islam. You will go on training
                missions and you will become who God created you to be, a soldier in His army that regularly shares their faith with others. A soldier who has been trained to battle through doubt and
                fear; to get to the front lines to share the saving Gospel of Jesus Christ.
              </p>
              <p>
                It does not matter what your personality is or what gender you are, your age doesn’t even matter. If you love Jesus, and want to serve Him the way He has called you to, then Evangelism
                Boot Camp is for you. After you become a Recruit, in a short period of time you will graduate and become an “Elite Soldier in God’s Army!” You will be the soldier God created you to
                be; a soldier with feet fitted with the readiness to share the Gospel.
              </p>
              <p>
                God used Jesse to make evangelism training exciting, just at the right time! This isn’t only for individuals, but for small groups, families and overall church training. I couldn’t
                encourage you more to complete Evangelism Boot Camp and become the soldier God created you to be! No one should miss this!
              </p>
              <p>Until the whole world hears,</p>
              <p>Josh McDowell</p>
              <p>Josh.org</p>

              <br />

              <p>
                <b>Additional Endorsements:</b>
              </p>

              <p>
                “It is an honor to recommend Evangelism Boot Camp for your church. I have known the author of this material, Jesse Connors (Founder of TrueLife.org), for many years. Trust me when I
                say that he has a genuine passion for the church, and especially for reaching the unsaved. As a Professor of Evangelism at Liberty University, I have been blessed to teach over 40,000
                students and have worked with hundreds of churches. I'm always looking for the best tools to share the Gospel! I've utilized his website, TrueLife.org, on a weekly basis, and my
                students absolutely love it! I've recently read through the entire Evangelism Boot Camp work book, it makes evangelism training fun, easy and effective. It's just what you and your
                church needs. Therefore, I highly encourage you to consider using Evangelism Boot Camp and TrueLife.org to better mobilize your congregation into the harvest fields . . . you will not
                regret it!”
              </p>

              <p></p>
              <p>
                <b>Dr. David Wheeler Professor of Evangelism, Liberty Univeristy</b>
              </p>
              <br />

              <p>
                “Since the day I met Jesse, almost ten years ago, he has been tuned in to God’s heart for evangelism. I’m not surprised at all to see how God used him to write an all inclusive
                evangelism training program. This program is easy; and no matter your age, God will use this book to challenge, encourage and impact your heart to reach others with the Gospel. I
                highly recommend ‘Evangelism Boot Camp’ for you and your church. When your training is complete, you’ll be anchored and better equipped to share the message of hope we have in Christ
                to a lost and broken world.”
              </p>

              <p>
                <b>Dr. Tim Clinton President of the American Association of Christian Counselors</b>
              </p>
              <br />

              <p>
                I firmly believe that now is the time to go all in on sharing your faith and spreading the good news of Jesus Christ. Evangelism Boot Camp gives you the tools, knowledge, and
                confidence that you need to get out there! Can you imagine the overwhelming feeling of meeting someone in heaven that you led to the Lord? I'm confident that if you take action by
                following the program inside this book, you won't have to imagine that feeling - you will one day experience it!
              </p>

              <p>
                <b>Ben Allison, Esq., MBA CEO, American Association of Christian Counselors</b>
              </p>
              <br />
              <br />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="isDesktop ? 8 : 24">
        <a-card title="Evangelism Boot Camp">
          <p>If you order 10 or more copies of you get 25% off on your order. Let us know how many you want of each below and we will confirm with you over email about your order.</p>
          <div class="text-center"><a-input-number id="orderCopies" v-model="orderCopies" :min="1" :max="1000" /> copies</div>
          <div style="margin-top: 2rem; display: flex; align-items: center; justify-content: space-around;">
            <a-button type="primary" @click="sendOrderRequest" :disabled="orderCopies < 1" ghost> Send Order</a-button>
            <a-button type="primary" @click="openEvangelismbootcamp('https://www.amazon.com/Evangelism-Boot-Camp-effective-actively/dp/B099C8S5YQ')" ghost> Order on Amazon </a-button>
          </div>
        </a-card>
        <a-card title="Small Group Leader Guide">
          <a-button type="primary" @click="openEvangelismbootcamp('https://www.amazon.com/Evangelism-Boot-Camp-Small-Leader/dp/B0B9PZ78MS')" ghost> Order on Amazon </a-button>
        </a-card>
        <a-card title="Explore EvangelismBootCamp.org">
          <a-button type="primary" @click="openWebsite" ghost> Go to Website </a-button>
        </a-card>
        <a-card title="Share Your Testimony" v-if="false">
          Ready to share your testimonty with others?
          <br />
          <br />
          <a-button type="primary" ghost> Share your story </a-button>
        </a-card>
      </a-col>
    </a-row>
    <edit-shipping-info v-if="isShippingVisible" @onClose="isShippingVisible = false"></edit-shipping-info>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { includes, isEmpty } from 'lodash';
import ProductService from '@/services/ProductService';
import EditShippingInfo from '@/components/EditShippingInfo';
export default {
  data() {
    return {
      orderCopies: 1,
      isShippingVisible: false,
    };
  },
  components: {
    EditShippingInfo,
  },
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    videoUrl() {
      const { user } = this.$store.state;
      return this.instructionVideo(includes(user.user.role, 'individual') ? 'I_Evangelism_BC_LINK' : 'P_Evangelism_BC_LINK');
    },
  },
  methods: {
    openEvangelismbootcamp(link) {
      window.open(link, '_blank');
    },
    openWebsite() {
      window.open('https://www.evangelismbootcamp.org', '_blank');
    },
    async sendOrderRequest() {
      try {
        const shippingInfo = this.user.user.shippingInfo;
        if (isEmpty(shippingInfo)) {
          this.isShippingVisible = true;
          return;
        }

        await ProductService.doCheckout(1, this.orderCopies);

        this.$notification['success']({
          message: 'Sent Order Request',
          description: 'Your Order Request has been sent successfully!',
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss">
.dashboard-container {
  padding: 20px;
  .bootcamp {
    button {
      height: auto;
      padding: 10px;
      text-transform: uppercase;
    }
  }

  .ebook-wrapper {
    p {
      // white-space: pre-line;
    }
  }
}
</style>
